<template>
  <div v-if="user" class="user-content-section">
    <div class="page-sub-title user-sub-title">
      <h2>
        <i class="fa-title"></i>
        <div>{{ $t("invite_friends") }}</div>
      </h2>
    </div>
    <div class="cart-login">
      <div class="courses-title-frame cart-title invite-title">
        <i class="fa-title"></i>
        <h2>
          <div>{{ $t("copy_referral_code") }}</div>
        </h2>
      </div>
      <div class="social-row">
        <div class="cart-social-ref">
          <div class="cart-social">
            <span>{{ $t("for_website") }}</span>
            <p class="invite-link" @click="copy($event.target.textContent)">
              <i class="fa-copy"></i
              ><span>{{ loc }}/?referrer={{ user.ref }}</span>
            </p>
          </div>
        </div>
        <div class="cart-social-ref">
          <div class="cart-social">
            <span>{{ $t("for_mobile") }}</span>
            <p class="invite-link" @click="copy($event.target.textContent)">
              <i class="fa-copy"></i><span>{{ user.ref }}</span>
            </p>
          </div>
        </div>
      </div>

      <div class="courses-title-frame cart-title invite-title">
        <i class="fa-title"></i>
        <h2>
          <div>{{ $t("how_to_earn_bonus") }}</div>
        </h2>
      </div>
      <div class="social-row">
        <div class="social-login">
          <div class="cart-social">
            <img src="../../assets/images/referral.svg" alt="" />
            <h3>
              <div>{{ $t("step_1") }}</div>
            </h3>
          </div>
        </div>
        <div class="social-login">
          <div class="cart-social">
            <img src="../../assets/images/authentication.svg" alt="" />
            <h3>
              <div>{{ $t("step_2") }}</div>
            </h3>
          </div>
        </div>
        <div class="social-login">
          <div class="cart-social">
            <img src="../../assets/images/credit-card.svg" alt="" />
            <h3>
              <div>{{ $t("step_3") }}</div>
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  title: "Do`stingizni taklif qilish",
  data() {
    return {
      loc: document.location.origin,
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUserCredentials;
    },
  },
  methods: {
    copy(str) {
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$store.commit("setNotification", "copy");
    },
  },
};
</script>
